export default __webpack_public_path__ + "static/media/gantry.25e380ec.svg";